module.exports = __webpack_public_path__ + "static/media/IMG_20180623_095756.f03d39b6.jpg";